import { render, staticRenderFns } from "./TabColumnView.vue?vue&type=template&id=414183a3&lang=pug"
import script from "./TabColumnView.vue?vue&type=script&lang=js"
export * from "./TabColumnView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414183a3')) {
      api.createRecord('414183a3', component.options)
    } else {
      api.reload('414183a3', component.options)
    }
    module.hot.accept("./TabColumnView.vue?vue&type=template&id=414183a3&lang=pug", function () {
      api.rerender('414183a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/datasource/TabColumnView.vue"
export default component.exports